export const DESKTOP_SECOND_LEVEL_NAVIGATION_PREFIX = "DesktopGlobalNavigation";

export const DESKTOP_SECOND_LEVEL_NAVIGATION_CLASSES = {
  item: `${DESKTOP_SECOND_LEVEL_NAVIGATION_PREFIX}-item`,
  optionItem: `${DESKTOP_SECOND_LEVEL_NAVIGATION_PREFIX}-optionItem`,
  hidden: `${DESKTOP_SECOND_LEVEL_NAVIGATION_PREFIX}-hidden`,
};
